import React from 'react';

interface Props {
  color?: string;
  width?: string;
  height?: string;
}
const WelcomeGift: React.FC<Props> = ({
  color = '#fff',
  height = '79',
  width = '79',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 79 79"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectángulo_40840"
          data-name="Rectángulo 40840"
          width="67.45"
          height="69.96"
          transform="translate(0 0)"
          fill={color}
        />
      </clipPath>
    </defs>
    <g
      id="Grupo_180139"
      data-name="Grupo 180139"
      transform="translate(-1383 -239)"
    >
      <rect
        id="Rectángulo_40841"
        data-name="Rectángulo 40841"
        width="79"
        height="79"
        transform="translate(1383 239)"
        fill="none"
      />
      <g
        id="Grupo_180138"
        data-name="Grupo 180138"
        transform="translate(1389 244)"
      >
        <g
          id="Grupo_180138-2"
          data-name="Grupo 180138"
          clipPath="url(#clip-path)"
        >
          <path
            id="Trazado_520864"
            data-name="Trazado 520864"
            d="M49.49,16a9.8,9.8,0,0,0,2.76-6.83V8.5A8.519,8.519,0,0,0,43.75,0,17.373,17.373,0,0,0,31.38,5.12a17.171,17.171,0,0,0-3.63,5.29A17.5,17.5,0,0,0,11.75,0a8.512,8.512,0,0,0-8.5,8.5v.67A9.8,9.8,0,0,0,6.01,16H0V35H2V61.5H27.26a23.859,23.859,0,0,1-1.35-3H21V19H34.5V31.17a21.539,21.539,0,0,1,3-1.78V19h15v8.44a21.372,21.372,0,0,1,3,.81V16ZM18,58.5H5V35H18ZM18,32H3V19H18ZM13.08,16A6.833,6.833,0,0,1,6.25,9.17V8.5A5.5,5.5,0,0,1,11.75,3,14.487,14.487,0,0,1,26.17,16ZM49.25,9.17A6.839,6.839,0,0,1,42.42,16H29.32A14.508,14.508,0,0,1,43.75,3a5.51,5.51,0,0,1,5.5,5.5ZM41.05,58.5l-.03.05h3.81l.03-.05Z"
            fill={color}
          />
          <path
            id="Trazado_520865"
            data-name="Trazado 520865"
            d="M41.9,42.03a3.614,3.614,0,0,0-3.86,3.91,3.611,3.611,0,0,0,3.86,3.9,3.594,3.594,0,0,0,3.83-3.9,3.6,3.6,0,0,0-3.83-3.91m-.03,5.48c-.69,0-1.1-.49-1.1-1.57,0-1.11.41-1.6,1.1-1.6s1.14.49,1.14,1.6c0,1.08-.44,1.57-1.14,1.57"
            fill={color}
          />
          <path
            id="Trazado_520866"
            data-name="Trazado 520866"
            d="M41.05,58.5l-.03.05h3.81l.03-.05ZM53.5,42.29v.4l.22-.4Zm0,0v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05ZM53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05ZM53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05ZM53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05ZM53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05ZM53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05ZM53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05ZM53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05ZM53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05ZM53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05ZM53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05ZM53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05Z"
            fill={color}
          />
          <path
            id="Trazado_520867"
            data-name="Trazado 520867"
            d="M41.9,42.03a3.614,3.614,0,0,0-3.86,3.91,3.611,3.611,0,0,0,3.86,3.9,3.594,3.594,0,0,0,3.83-3.9,3.6,3.6,0,0,0-3.83-3.91m-.03,5.48c-.69,0-1.1-.49-1.1-1.57,0-1.11.41-1.6,1.1-1.6s1.14.49,1.14,1.6c0,1.08-.44,1.57-1.14,1.57"
            fill={color}
          />
          <path
            id="Trazado_520868"
            data-name="Trazado 520868"
            d="M53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05Z"
            fill={color}
          />
          <path
            id="Trazado_520869"
            data-name="Trazado 520869"
            d="M55.5,32.34a18.826,18.826,0,0,0-3-.99,19.2,19.2,0,0,0-4.64-.56A19.622,19.622,0,0,0,28.28,50.38a19.32,19.32,0,0,0,1.77,8.12,17.089,17.089,0,0,0,1.71,3A19.58,19.58,0,1,0,55.5,32.34M47.86,66.96c-.32,0-.64-.01-.95-.03a1.949,1.949,0,0,1-.25-.02c-.27-.02-.54-.04-.8-.08-.23-.02-.46-.05-.68-.09s-.46-.08-.69-.13c-.17-.03-.34-.07-.51-.11-.01,0-.03-.01-.04-.01-.12-.03-.22-.05-.34-.09-.22-.05-.44-.12-.66-.19a4.969,4.969,0,0,1-.65-.22c-.04-.01-.07-.03-.11-.04-.16-.05-.31-.11-.46-.17-.01-.01-.03-.01-.04-.02-.17-.06-.33-.14-.5-.21q-.51-.225-.99-.48a5.207,5.207,0,0,1-.56-.31,1.4,1.4,0,0,1-.17-.09c-.01-.01-.02-.01-.03-.02-.16-.09-.31-.19-.47-.3h-.01a2.255,2.255,0,0,1-.36-.24c-.22-.14-.43-.29-.64-.45-.27-.2-.54-.41-.79-.63a2.911,2.911,0,0,1-.27-.24,9.33,9.33,0,0,1-.73-.68c-.19-.18-.37-.37-.54-.56l-.05-.05c-.25-.27-.48-.56-.72-.85a1.432,1.432,0,0,1-.11-.15c-.11-.14-.22-.29-.33-.44-.18-.25-.35-.5-.52-.76s-.33-.53-.48-.8c-.17-.3-.33-.61-.48-.92-.12-.25-.24-.5-.34-.76a3.474,3.474,0,0,1-.2-.5,3.517,3.517,0,0,1-.19-.51c-.09-.24-.17-.49-.24-.74a4.608,4.608,0,0,1-.15-.53q-.12-.465-.21-.93c-.06-.29-.11-.57-.15-.86v-.01a4.261,4.261,0,0,1-.06-.5.985.985,0,0,1-.02-.17,5.673,5.673,0,0,1-.05-.58v-.03c-.01-.15-.02-.31-.03-.46-.01-.21-.01-.41-.01-.62,0-.27.01-.54.02-.81.01-.3.04-.6.07-.9.02-.22.05-.44.08-.66V48c.03-.22.07-.44.11-.66.06-.32.13-.64.21-.95.03-.14.07-.29.11-.43.01-.04.02-.07.03-.11.04-.15.09-.31.14-.46a6.264,6.264,0,0,1,.21-.61c.03-.09.06-.18.09-.26a1.111,1.111,0,0,1,.07-.16c.12-.32.26-.64.4-.94.01-.03.03-.07.04-.1.09-.19.19-.38.29-.58.09-.17.18-.35.28-.52.02-.03.03-.06.05-.09.1-.17.2-.34.3-.5.23-.36.47-.72.72-1.06.03-.04.06-.08.08-.11.19-.26.39-.5.59-.74.24-.28.48-.55.73-.81s.51-.52.77-.76c.02-.02.04-.03.05-.05q.375-.33.78-.66c.31-.25.63-.49.97-.72.14-.1.28-.2.43-.29.17-.11.35-.23.53-.33a13.292,13.292,0,0,1,1.68-.86c.17-.08.34-.16.51-.22.01-.01.03-.01.04-.02a.142.142,0,0,1,.06-.02q.36-.15.72-.27a.88.88,0,0,1,.15-.05q.33-.12.66-.21l.09-.03a.235.235,0,0,1,.08-.02c.14-.04.29-.08.44-.12.17-.04.35-.08.53-.12s.36-.07.54-.1a4.543,4.543,0,0,1,.51-.09.875.875,0,0,1,.16-.02c.19-.03.38-.05.57-.07a4.382,4.382,0,0,1,.52-.04,3.44,3.44,0,0,1,.46-.03c.23-.01.47-.02.71-.02s.48.01.71.02a3.44,3.44,0,0,1,.46.03,4.381,4.381,0,0,1,.52.04c.19.02.38.04.57.07a.875.875,0,0,1,.16.02,4.543,4.543,0,0,1,.51.09c.18.03.36.06.54.1s.36.08.53.12c.21.05.41.11.61.17.16.05.31.09.46.14s.3.09.45.15c.23.08.46.17.68.26s.45.19.67.29c.08.03.15.07.22.1s.16.07.23.11a11.213,11.213,0,0,1,1.08.58c.13.08.26.16.4.24.27.18.55.36.81.55s.52.39.78.59a4.031,4.031,0,0,1,.32.26c.23.19.45.39.66.59.13.12.25.24.37.36a5.775,5.775,0,0,1,.42.44c.1.11.2.21.29.32.02.01.03.03.04.04a15.888,15.888,0,0,1,1.52,2.04c.11.17.22.34.32.52.15.26.29.52.43.78l.06.12c.13.27.26.54.38.81.07.16.14.32.2.48.11.27.21.54.3.82a.564.564,0,0,1,.04.12,5.575,5.575,0,0,1,.18.58c.04.12.08.24.11.36.05.19.1.38.14.57.09.38.16.76.22,1.15a2.887,2.887,0,0,1,.04.29c.03.19.05.38.07.57q.045.36.06.72a1.21,1.21,0,0,1,.01.19c.01.26.02.52.02.79A16.6,16.6,0,0,1,47.86,66.96"
            fill={color}
          />
          <path
            id="Trazado_520870"
            data-name="Trazado 520870"
            d="M53.5,51.03a4.35,4.35,0,0,0-.63-.04,4.063,4.063,0,0,0-2.37.68,4.262,4.262,0,0,0,0,6.44,4.068,4.068,0,0,0,2.37.69,4.35,4.35,0,0,0,.63-.04,3.546,3.546,0,0,0,3.2-3.86,3.537,3.537,0,0,0-3.2-3.87m0,5.24a1.1,1.1,0,0,1-.66.2c-.69,0-1.1-.49-1.1-1.57s.41-1.6,1.1-1.6a1.042,1.042,0,0,1,.66.21,1.713,1.713,0,0,1,.48,1.39,1.68,1.68,0,0,1-.48,1.37"
            fill={color}
          />
          <path
            id="Trazado_520871"
            data-name="Trazado 520871"
            d="M41.9,42.03a3.614,3.614,0,0,0-3.86,3.91,3.611,3.611,0,0,0,3.86,3.9,3.594,3.594,0,0,0,3.83-3.9,3.6,3.6,0,0,0-3.83-3.91m-.03,5.48c-.69,0-1.1-.49-1.1-1.57,0-1.11.41-1.6,1.1-1.6s1.14.49,1.14,1.6c0,1.08-.44,1.57-1.14,1.57M53.5,42.29v.4l.22-.4ZM41.05,58.5l-.03.05h3.81l.03-.05Z"
            fill={color}
          />
          <path
            id="Trazado_520872"
            data-name="Trazado 520872"
            d="M53.5,42.29v.4l-3,5.49L44.86,58.5H41.05l8.86-16.21Z"
            fill={color}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default WelcomeGift;
